import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/atoms/ui/dialog';
import { Button } from '@/components/atoms/ui/button';

export interface UnsavedChangesDialogProps {
  /**
   * Whether the dialog is open
   */
  open: boolean;
  /**
   * Callback when user chooses to cancel (stay on page)
   */
  onCancel: () => void;
  /**
   * Callback when user chooses to proceed (navigate away)
   */
  onProceed: () => void;
}

/**
 * Dialog component to warn users about unsaved changes
 */
export const UnsavedChangesDialog = ({
  open,
  onCancel,
  onProceed,
}: UnsavedChangesDialogProps) => {
  return (
    <Dialog open={open} onOpenChange={(isOpen) => !isOpen && onCancel()}>
      <DialogContent className="unsaved-changes-dialog-component sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Dikkat! Kaydedilmemiş değişiklikler var</DialogTitle>
          <DialogDescription>
            Sayfadan ayrılmak üzere olduğunuz için kaydedilmemiş değişiklikler
            kaybolacak. Devam etmek istediğinizden emin misiniz?
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-0">
          <Button variant="outline" onClick={onCancel}>
            Vazgeç
          </Button>
          <Button onClick={onProceed} variant="destructive">
            Devam Et
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};


